import { render, staticRenderFns } from "./CouponFilters.vue?vue&type=template&id=5b415f2e&"
import script from "./CouponFilters.vue?vue&type=script&lang=js&"
export * from "./CouponFilters.vue?vue&type=script&lang=js&"
import style0 from "./CouponFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports